import { render, staticRenderFns } from "./FoodAssest.vue?vue&type=template&id=bd24a726&scoped=true"
import script from "./FoodAssest.vue?vue&type=script&lang=js"
export * from "./FoodAssest.vue?vue&type=script&lang=js"
import style0 from "./FoodAssest.vue?vue&type=style&index=0&id=bd24a726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd24a726",
  null
  
)

export default component.exports